import { Settings } from "lucide-react";

import { Section } from "@/components/Section";

const ENV_LABEL =
  (import.meta.env.VITE_BACKSTAGE_ENV as string | undefined) ?? "local";
const RELEASE =
  (import.meta.env.VITE_RELEASE as string | undefined) ?? "0.0.0";
const API_BASE =
  (import.meta.env.VITE_API_BASE as string | undefined) ?? "/api/v1";

export function GlobalSettings() {
  return (
    <Section title="Environment" icon={<Settings />}>
      <div className="kv">
        <span className="k">environment</span>
        <span className="v mono">{ENV_LABEL}</span>
        <span className="k">release</span>
        <span className="v mono">v{RELEASE}</span>
        <span className="k">api_base</span>
        <span className="v mono">{API_BASE}</span>
        <span className="k">timezone</span>
        <span className="v mono">{Intl.DateTimeFormat().resolvedOptions().timeZone}</span>
      </div>
      <p className="muted" style={{ marginTop: 16, fontSize: 13 }}>
        Most controller settings are managed via environment variables; see{" "}
        <code>controller/controller/config.py</code> for the full schema.
      </p>
    </Section>
  );
}
